var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.innerVisible,
        width: "400px",
        height: "300px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "200px" },
        attrs: {
          "show-side-bar": false,
          "grid-options": _vm.accountGrid.gridOptions,
          "column-defs": _vm.accountGrid.columnDefs,
          "row-data": _vm.accountGrid.rowData
        },
        on: {
          gridReady: function(gridParams) {
            return (_vm.accountGrid.gridApi = gridParams.api)
          }
        }
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-radio-group",
            {
              on: { change: _vm.jobChanged },
              model: {
                value: _vm.groupAr,
                callback: function($$v) {
                  _vm.groupAr = $$v
                },
                expression: "groupAr"
              }
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Revenue")))
              ]),
              _c("el-radio", { attrs: { label: 0 } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrimeCost")))
              ])
            ],
            1
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Copy2")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.visible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }